const SUB_ACCOUNT_ALLOWED_EXACT = ["/home", "/projects"];
const SUB_ACCOUNT_ALLOWED_PATTERNS = [/^\/editor\//];

export function getAccountType() {
  try {
    const info = JSON.parse(localStorage.getItem("userInfo") || "{}");
    return Number(info.accountType) === 1 ? 1 : 0;
  } catch {
    return 0;
  }
}

export function isSubAccount(accountType = getAccountType()) {
  return accountType === 1;
}

export function isRouteAllowedForAccount(path, accountType = getAccountType()) {
  if (accountType !== 1) return true;
  if (SUB_ACCOUNT_ALLOWED_EXACT.includes(path)) return true;
  return SUB_ACCOUNT_ALLOWED_PATTERNS.some((pattern) => pattern.test(path));
}
